import { render, staticRenderFns } from "./PasswordResetSetNewPassword.vue?vue&type=template&id=d0c60f5c&scoped=true"
import script from "./PasswordResetSetNewPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordResetSetNewPassword.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PasswordResetSetNewPassword.vue?vue&type=style&index=0&id=d0c60f5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c60f5c",
  null
  
)

export default component.exports